import { render, staticRenderFns } from "./Mensaje.vue?vue&type=template&id=5c958eee&"
import script from "./Mensaje.vue?vue&type=script&lang=js&"
export * from "./Mensaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports